export const CLIENT_INFO = 'Информация о клиенте';
export const BIRTH_YEAR = 'Год рождения';
export const GENDER = 'Пол';
export const INSTITUTION = 'Учреждение';
export const QUESTIONS = 'Кто отвечает на вопросы';
export const DIAGNOSIS = 'Основной диагноз';
export const ADDITIONAL_INFORMATION = 'Дополнительные сведения';
export const CLIENT_REQUEST = 'Запрос клиента';
export const USER_AGREEMENT = 'Пользовательские соглашения';
export const GOAL_TITLE = 'Цель и ее достижение';
export const GOAL = 'Цель';
export const PROGRAM = 'Программа';
export const PLAN = 'План достижения цели';
export const ESTIMATE = 'Оценки';
export const ADD_ESTIMATE = 'Добавить оценку';
export const PDF = 'Выгрузить PDF';
export const AGREEMENT_SUCCESS = 'Согласие получено';
export const AGREEMENT_FAILURE = 'Согласие не получено';
export const SATISFACTION_RATING = 'Общее изменения оценки удовлетворенности';
export const PERFORMANCE_RATING = 'Общее изменения оценки выполнения';
export const VIOLATIONS = 'Основные виды нарушений';
export const SHOW_HISTORY = 'Показать историю';
